import { Pipe, PipeTransform } from '@angular/core';
import { GetDeliveryTimeWindow } from '@next/core-lib/cart';

@Pipe({ name: 'formatTimeWindow', standalone: true })
export class FormatTimeWindowPipe implements PipeTransform {
  public transform(value: GetDeliveryTimeWindow): string {
    return `${value?.timeFrom?.substr(0, 5)} - ${value?.timeTo?.substr(0, 5)}`;
  }
}
